import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as userActions from '../../../actions/usersActions';
import * as usersAction from '../../../actions/admin/user/userActions'
// import moment from 'moment';
// import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import { toastr } from 'react-redux-toastr';
import * as message from '../../../constants/messageConstants';
// import classNames from 'classnames';
import validator from '../../common/validator';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as SVGICONS from '../../../images/img/images';
import * as constant from '../../../constants/constant';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import CheckBox from '../user/checkBox';


class AdminSetting extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			patternOne: false,
			patternTwo: false,
			patternThree: false,
			patternFour: false,
			popoverShow: false,
			// bloodGroupList: [],
			// replicaBloodGroupList: [],
			image: { value: '', isValid: true, message: '' },

			gender: { value: '', isValid: true, message: '' },
			userName: { value: '', isValid: true, message: '' },
			transaction_charge: { value: '', isValid: true, message: '' },
			commition_charges: { value: '', isValid: true, message: '' },
			invoice_recurrance: { value: '', isValid: true, message: '' },
			phoneNo: { value: '', isValid: true, message: '' },
			email: { value: '', isValid: true, message: '' },
			// dateOfBirth: { value: null, isValid: true, message: '' },
			userId: '',
			// bloodGroup: { value: '', isValid: true, message: '' },
			userType: { value: '', isValid: true, message: '' },
			phoneNoCountryCode: { value: localStorage.getItem('calling_code'), isValid: true, message: '' },
			//for instead reflect image change
			tabClicked: 1,
			imageCopy: '',
			file: '',
			imagePreviewUrl: '',
			defaultImageURL: '',

			//change Password
			currentPassword: { value: '', isValid: true, message: '' },
			password: { value: '', isValid: true, message: '' },
			cpassword: { value: '', isValid: true, message: '' },
			items: [
				{ value: "admin", name: 'Admin', isChecked: false },
				{ value: "finance", name: 'Finance', isChecked: false },
				{ value: "feedback", name: 'Feedback', isChecked: false },
				{ value: "vetting", name: 'Vetting', isChecked: false },
				{ value: "specialistuser", name: 'Specialistuser', isChecked: false },
				{ value: "photouser", name: 'Photo User', isChecked: false },
				{ value: "patientuser", name: 'Patient User', isChecked: false },
				{ value: "specialistAssisstant", name: 'Specialist Assisstant', isChecked: false }
			],
			commisionData:[],
            invoicSettings:[],
            transctionData:[],


		}
		this.onChange = this.onChange.bind(this);
		// this.updateUserProfile = this.updateUserProfile.bind(this);
		this.uploadPatientImage = this.uploadPatientImage.bind(this);
		this.onPasswordSettingChange = this.onPasswordSettingChange.bind(this);
		this.changePassword = this.changePassword.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.resetValidationStates = this.resetValidationStates.bind(this);
		this.deleteProfile = this.deleteProfile.bind(this);
		this.onrenderimage = this.onrenderimage.bind(this);
		this.deleteImage = this.deleteImage.bind(this);
		this.addEditUser = this.addEditUser.bind(this);
		this.uploadAdminUserImage = this.uploadAdminUserImage.bind(this);
		this.savePaymentConfigration = this.savePaymentConfigration.bind(this);
	}

	onChange(event) {
		var state = this.state;
		state[event.target.name].value = event.target.value;


		//validation code
		if (event.target.name == "userName") {
			if (event.target.value.length > 0) {
				if (!validator.isValidName(event.target.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Please enter a valid name';
				} else {
					state[event.target.name].isValid = true;
					state.userName.message = '';
				}
			} else {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Name is Required';
			}
		}
		else if (event.target.name == "email") {
			if (event.target.value.length > 0) {
				if (!validator.isEmail(state.email.value)) {
					state[event.target.name].isValid = false;
					state[event.target.name].message = 'Not a valid email address';
					this.setState(state);
				} else {
					state[event.target.name].isValid = true;
					state[event.target.name].message = '';
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else if (event.target.name == "phoneNo") {
			if ((event.target.value).length == 0) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Phone number is required';
			} else if ((event.target.value).length > 10) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Max allowed length is 10';
			} else if (!validator.isOnlyNumber(event.target.value)) {
				state[event.target.name].isValid = false;
				state[event.target.name].message = 'Only numbers are allowed in phone number';
			} else if ((state.phoneNo.value).length < 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Min allowed length is 10';
			}
			else {
				state[event.target.name].isValid = true;
				state[event.target.name].message = ''
			}
		}

		this.setState(state);
	}
	resetValidationStates() {
		var state = this.state;

		Object.keys(state).map(key => {
			if (state[key].hasOwnProperty('isValid')) {
				state[key].isValid = true;
				state[key].message = '';
			}
		});
		this.setState(state);
	}

	deleteProfile() {

		confirmAlert({
			title: 'Confirm',
			message: 'Do you wish to Delete your account? ',
			buttons: [
				{
					label: 'Yes',
					onClick: () => {
						var obj = {
							userId: localStorage.getItem('userId')
						}
						this.props.actions.deletePatientAccount(obj);
					}
				},
				{
					label: 'No',
					onClick: () => { }
				}
			]
		})
	}

	handleChange(date) {


	}


	uploadPatientImage(event) {

		//To change the view immediately after uploading image 
		event.preventDefault();
		// this.resetValidationStates();
		if (event.target.name == "image") {
			if (event.target.files.length > 0) {
				if (!validator.ImageValidateFormate(event.target.files[0])) {
					toast.error('Please choose following format jpeg, jpg, png, gif')
				} else if (!validator.fileValidateSize(event.target.files[0])) {
					toast.error('File size must be less than 10 MB.')

				} else {
					let reader = new FileReader();
					let file = event.target.files[0];
					console.log(file)
					this.setState({
						image: { value: file },
						defaultImageURL: file
					})

					console.log(this.state.defaultImageURL)
					reader.onloadend = () => {
						this.setState({
							file: file,
							defaultImageURL: reader.result
						});
					}
					console.log(this.state.defaultImageURL)
					reader.readAsDataURL(file);


					this.setState({ [event.target.name]: event.target.files[0] });
					let patientObj = {
						file: event.target.files[0],
						userId: localStorage.getItem('userId')
					}
					this.props.actions.uploadPatientImage(patientObj);
				}
			}

		}

	}

	// **************** change function password section *********************


	onPasswordSettingChange(e) {
		var state = this.state;
		state[e.target.name].value = e.target.value;
		this.resetValidationStates();
		if (e.target.name == "password") {
			this.setState({ popoverShow: true })
			if (e.target.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					return true
				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} else if (e.target.name == "cpassword") {
			if (e.target.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					return true
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		} else
			if (e.target.name == "currentPassword") {
				if (e.target.value.length > 0) {
					if (!validator.isValid(state.currentPassword.value)) {
						state.currentPassword.isValid = false;
						state.currentPassword.message = 'Not a valid currentPassword';
						this.setState(state);
					} else {
						return true
					}
				} else {
					state.currentPassword.isValid = false;
					state.currentPassword.message = 'Current Password is required';
					this.setState(state);
				}
			}
		this.setState(state);
	}
	//api calling
	changePassword() {

		var state = this.state;
		if (state.password || !state.password) {
			this.setState({ popoverShow: true })
			if (state.password.value.length > 0) {
				if ((validator.atLeastOneLetter(state.password.value)) || (validator.atLeastOneCapitalLetter(state.password.value)) || (validator.atLeastOneNumber(state.password.value)) || (validator.atLeastEightCharacters(state.password.value))) {
					if (validator.atLeastOneLetter(state.password.value)) {
						state.patternOne = true;
					} else {
						state.patternOne = false;
					}
					if (validator.atLeastOneCapitalLetter(state.password.value)) {
						state.patternTwo = true;
					} else {
						state.patternTwo = false;
					}
					if (validator.atLeastOneNumber(state.password.value)) {
						state.patternThree = true;
					} else {
						state.patternThree = false;
					}
					if (validator.atLeastEightCharacters(state.password.value)) {
						state.patternFour = true;
					} else {
						state.patternFour = false;
					}
				} else {
					// return true
					state.password.message = '';
					state.password.isValid = true;

				}
				if (state.patternOne && state.patternTwo && state.patternThree && state.patternFour) {
					state.password.isValid = true;
					state.password.message = '';
					state.popoverShow = false;
				} else {
					state.password.isValid = false;
					state.password.message = 'Not a valid password';
					state.popoverShow = true;
				}
			} else {
				state.patternOne = false;
				state.patternTwo = false;
				state.patternThree = false;
				state.patternFour = false;
				state.password.isValid = false;
				state.password.message = 'Password is required';
				state.popoverShow = false;
			}
		} if (state.cpassword || !state.cpassword) {
			if (state.cpassword.value.length > 0) {
				if (state.password.value != state.cpassword.value) {
					state.cpassword.isValid = false;
					state.cpassword.message = 'Passwords do not match';
					this.setState(state);
				} else {
					state.cpassword.isValid = true;
					state.cpassword.message = '';
				}
			} else {
				state.cpassword.isValid = false;
				state.cpassword.message = 'Confirm password is required';
				this.setState(state);
			}

		}
		if (state.currentPassword || !state.currentPassword) {
			if (state.currentPassword.value.length > 0) {
				if (!validator.isValid(state.currentPassword.value)) {
					state.currentPassword.isValid = false;
					state.currentPassword.message = 'Not a valid currentPassword';
					this.setState(state);
				} else {
					state.currentPassword.isValid = true;
					state.currentPassword.message = '';
				}
			} else {
				state.currentPassword.isValid = false;
				state.currentPassword.message = 'Current Password is required';
				this.setState(state);
			}
		}


		if (this.state.password.value != '' && this.state.cpassword.value != '' && this.state.currentPassword.value != '' && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.cpassword.message == '' || this.state.cpassword.message == undefined) && (this.state.currentPassword.message == '' || this.state.currentPassword.message == undefined) && (this.state.patternOne == true) && (this.state.patternTwo == true) && (this.state.patternThree == true) && (this.state.patternFour == true)) {
			if (this.state.password.value == this.state.cpassword.value) {
				let passwordObj = {
					userId: localStorage.getItem('userId'),
					oldPassword: this.state.currentPassword.value,
					newPassword: this.state.password.value
				}
				this.props.actions.changePassword(passwordObj);
				this.setState({
					currentPassword: { value: '' },
					password: { value: '' },
					cpassword: { value: '' },
					popoverShow: false
				});

			} else {
				toast.error(message.PASSWORDS_DIFFERENT);
				this.setState({
					currentPassword: { value: '' },
					password: { value: '' },
					cpassword: { value: '' },
					popoverShow: false
				});
			}
		}

	}

	componentWillMount() {


		let userId = localStorage.getItem('userId')

		// this.setState({ ...this.state.phoneNoCountryCode, value: localStorage.getItem('calling_code') });
		console.log(this.state.phoneNoCountryCode)
		this.props.usersAction.getUserById(userId);
		// this.props.actions.getBloodGroupList();
		// this.props.actions.getBloodGroupList();
		this.props.usersAction.getPaymentConfig();

	}

	addEditUser(event) {
		event.preventDefault();
		let state = this.state;
		let permissionData = state.items.filter(item => item.isChecked == true);
		if (permissionData.length == 0) {
			state.userType.isValid = false;
			state.userType.message = 'Please select user type';
			this.setState(state);
		}
		if (state.userName || !state.userName) {
			if (state.userName.value != undefined && state.userName.value != "") {
				if (!validator.isValidName(state.userName.value)) {
					state.userName.isValid = false;
					state.userName.message = 'Please enter a valid name';
					this.setState(state);
				} else {
					state.userName.isValid = true;
					state.userName.message = '';
					this.setState(state);
				}
			} else {
				state.userName.isValid = false;
				state.userName.message = 'Name is Required';
				this.setState(state);
			}
		} else {
			state.userName.isValid = false;
			state.userName.message = 'Name is Required';
			this.setState(state);
		}

		if (state.email || !state.email) {
			if ((state.email.value != undefined && state.email.value != "") || document.getElementById('email').value != '') {

				if (!validator.isEmail(state.email.value) && !validator.isEmail(document.getElementById('email').value)) {
					state.email.isValid = false;
					state.email.message = 'Not a valid email address';
					this.setState(state);
				} else {
					state.email.isValid = true;
					state.email.message = '';
					this.setState(state);
				}
			} else {
				state.email.isValid = false;
				state.email.message = 'Email address is required';
				this.setState(state);
			}

		} else {
			state.email.isValid = false;
			state.email.message = 'Email address is required';
			this.setState(state);
		}

		if (state.phoneNo || !state.phoneNo) {

			if ((state.phoneNo.value == '' || state.phoneNo.value == undefined) && document.getElementById('phoneNo').value == '') {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Phone number is required';
			} else if ((state.phoneNo.value).length > 10 || document.getElementById('phoneNo').value.length > 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Max allowed length is 10';
			} else if ((state.phoneNo.value).length < 10 || document.getElementById('phoneNo').value.length > 10) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Min allowed length is 10';
			}
			else if (!validator.isOnlyNumber(state.phoneNo.value) || !validator.isOnlyNumber(document.getElementById('phoneNo').value)) {
				state.phoneNo.isValid = false;
				state.phoneNo.message = 'Only numbers are allowed in phone number';
			}
			else {
				state.phoneNo.isValid = true;
				state.phoneNo.message = ''
			}
		}

		let userId = localStorage.getItem('userId')
		if (this.state.userName.value != '' && this.state.phoneNo.value != '' && this.state.email.value != '' && (this.state.phoneNo.message == '' || this.state.phoneNo.message == undefined) && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.userName.message == '' || this.state.userName.message == undefined)
			&& (this.state.gender.message == '' || this.state.gender.message == undefined)
			&& (this.state.userType.message == '' || this.state.userType.message == undefined)
		) {
			let user = {
				userName: this.state.userName.value,
				gender: this.state.gender.value,
				phoneNo: this.state.phoneNo.value,
				email: this.state.email.value,
				phoneNoCountryCode: this.state.phoneNoCountryCode.value ? this.state.phoneNoCountryCode.value : '+91',
				permissionData: this.state.items,
				userId: userId
			}
			this.props.usersAction.updateUser(user);

		}
	}
	uploadAdminUserImage(event) {
		//To change the view immediately after uploading image 
		event.preventDefault();
		// this.resetValidationStates();
		if (event.target.name == "image") {
			if (event.target.files.length > 0) {
				if (!validator.ImageValidateFormate(event.target.files[0])) {
					toast.error('Please choose following format jpeg, jpg, png, gif')
				} else if (!validator.fileValidateSize(event.target.files[0])) {
					toast.error('File size must be less than 10 MB.')

				} else {
					let reader = new FileReader();
					let file = event.target.files[0];
					this.setState({
						image: { value: file },
					})
					reader.onloadend = () => {
						this.setState({
							file: file,
							imagePreviewUrl: reader.result
						});
					}

					reader.readAsDataURL(file);


					this.setState({ [event.target.name]: event.target.files[0] });
					let patientObj = {
						file: event.target.files[0],
						userId: localStorage.getItem('userId')
					}
					this.props.usersAction.uploadAdminUserImage(patientObj);
				}
			}

		}

	}
	componentWillReceiveProps(nextProps) {
		console.log("-------------+++++++++++++++++(((==>, ", nextProps)
		var state = this.state;
		state.file = '';
		state.userName = { value: (nextProps.userData.userName) ? nextProps.userData.userName : state.userName.value },
			state.gender = { value: nextProps.userData.gender ? nextProps.userData.gender : state.gender.value },
			state.image = { value: nextProps.userData.adminProfileImage ? nextProps.userData.adminProfileImage : state.image.value },

			// state.bloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.bloodGroupList,
			// state.replicaBloodGroupList = (nextProps.bloodGroupList) ? nextProps.bloodGroupList : state.replicaBloodGroupList,
			state.email = { value: nextProps.userData.email ? nextProps.userData.email : state.email.value, email: nextProps.userData.email },
			// state.dateOfBirth = { value: nextProps.userData.dateOfBirth ? moment(nextProps.userData.dateOfBirth) : this.state.dateOfBirth.value },
			// state.bloodGroup = { value: nextProps.userData.bloodGroup ? nextProps.userData.bloodGroup : state.bloodGroup.value },
			state.items = nextProps.userData.permission ? nextProps.userData.permission : this.state.items,
			state.phoneNo = { value: nextProps.userData.phoneNo ? nextProps.userData.phoneNo.toString() : state.phoneNo.value },
			state.imageCopy = nextProps.userData.adminProfileImage ? nextProps.userData.adminProfileImage : state.imageCopy,
			state.phoneNoCountryCode = { value: nextProps.userData.phoneNoCountryCode ? nextProps.userData.phoneNoCountryCode : state.phoneNoCountryCode.value },

			this.setState({ state });

		// if (this.state.bloodGroupList && this.state.bloodGroupList.length == 0) {
		// 	this.props.actions.getBloodGroupList();
		// }
		if (localStorage.getItem('isClicked') === "true") {
			localStorage.removeItem('isClicked')

			this.setState({
				tabCLicked: 1
			})

		}
		if (nextProps.paymentConfigData && nextProps.paymentConfigData.commisionData) {
			this.setState({
				commisionData: nextProps.paymentConfigData.commisionData[0],
				invoicSettings: nextProps.paymentConfigData.invoicSettings[0],
				transctionData: nextProps.paymentConfigData.transctionData[0],

			})
			state.commition_charges = { value: nextProps.paymentConfigData.commisionData ? nextProps.paymentConfigData.commisionData[0].amount : state.commition_charges.value },
				state.transaction_charge = { value: nextProps.paymentConfigData.transctionData ? nextProps.paymentConfigData.transctionData[0].amount : state.transaction_charge.value },
				state.invoice_recurrance = { value: nextProps.paymentConfigData.invoicSettings ? nextProps.paymentConfigData.invoicSettings[0].invoice_Day : state.invoice_recurrance.value }

		}

	}
	componentDidMount() {

		this.setState({
			tabCLicked: 1
		})
		// this.setState({ ...this.state.phoneNoCountryCode, value: localStorage.getItem('calling_code') });
		// this.props.actions.getBloodGroupList();

	}
	onChangeTab(data) {

		this.setState({

			tabCLicked: data
		});

	}
	deleteImage() {
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

		var delImage = {
			userId: user._id,
			userType: 'Admin'
		}
		this.props.usersAction.deleteImageProfile(delImage);
	}
	onrenderimage() {
		if (this.state.imageCopy == '' || this.state.imageCopy == 'noUserImage.jpg') {
			localStorage.setItem('Gender', this.state.gender.value)
			if (this.state.gender.value == 'Male') {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_m.png'
			}
			else {
				this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + constant.COMMON_FOLDER + 'patient_f.png'
			}
		}
		else {
			this.state.defaultImageURL = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + '/' + 'admin' + '/' + this.state.imageCopy
		}
	}
	savePaymentConfigration(event) {
		event.preventDefault();
		let that = this
		let state = that.state;

		if (state.commition_charges || !state.commition_charges) {
			if (state.commition_charges.value != undefined && state.commition_charges.value != "") {
				if (!validator.isOnlyNumber(state.commition_charges.value)) {
					state.commition_charges.isValid = false;
					state.commition_charges.message = 'Commition charges is Required';
					this.setState(state);
				} else {
					state.commition_charges.isValid = true;
					state.commition_charges.message = '';
					this.setState(state);
				}
			} else {
				state.commition_charges.isValid = false;
				state.commition_charges.message = 'Commition charges is Required';
				this.setState(state);
			}
		} else {
			state.commition_charges.isValid = false;
			state.commition_charges.message = 'Commition charges is Required';
			this.setState(state);
		}
		if (state.transaction_charge || !state.transaction_charge) {
			if (state.transaction_charge.value != undefined && state.transaction_charge.value != "") {
				if (!validator.isOnlyNumber(state.transaction_charge.value)) {
					state.transaction_charge.isValid = false;
					state.transaction_charge.message = 'Transaction charges is Required';
					this.setState(state);
				} else {
					state.transaction_charge.isValid = true;
					state.transaction_charge.message = '';
					this.setState(state);
				}
			} else {
				state.transaction_charge.isValid = false;
				state.transaction_charge.message = 'Transaction charges is Required';
				this.setState(state);
			}
		} else {
			state.transaction_charge.isValid = false;
			state.transaction_charge.message = 'Transaction charges is Required';
			this.setState(state);
		}
		if (state.invoice_recurrance || !state.invoice_recurrance) {
			if (state.invoice_recurrance.value != undefined && state.invoice_recurrance.value != "") {
				if (!validator.isOnlyNumber(state.invoice_recurrance.value)) {
					state.invoice_recurrance.isValid = false;
					state.invoice_recurrance.message = 'Invoice recurrance is Required';
					this.setState(state);
				} else {
					state.invoice_recurrance.isValid = true;
					state.invoice_recurrance.message = '';
					this.setState(state);
				}
			} else {
				state.invoice_recurrance.isValid = false;
				state.invoice_recurrance.message = 'Invoice recurrance is Required';
				this.setState(state);
			}
		} else {
			state.invoice_recurrance.isValid = false;
			state.invoice_recurrance.message = 'Invoice recurrance is Required';
			this.setState(state);
		}



		let userId = localStorage.getItem('userId')
		if (this.state.invoice_recurrance.value != '' && this.state.transaction_charge.value != '' && this.state.commition_charges.value != '') {
			let obj1 = {
				amount: parseInt(this.state.commition_charges.value),
				_id: this.state.commisionData && this.state.commisionData._id ? this.state.commisionData._id : '5c76980df22fd42ee87a0eef',

			}
			this.props.usersAction.CreateCommition(obj1);
			let obj2 = {
				amount: parseInt(this.state.transaction_charge.value),
				_id: this.state.transctionData && this.state.transctionData._id ? this.state.transctionData._id : '5c76980df22fd42ee87a0eef',
			}
			this.props.usersAction.TransactionFee(obj2);
			let obj3 = {
				invoiceDay: parseInt(this.state.invoice_recurrance.value),
				invoiceDayId: this.state.invoicSettings && this.state.invoicSettings._id ? this.state.invoicSettings._id : '5c76980df22fd42ee87a0eef'
			}
			this.props.usersAction.SubmitInvoiceDay(obj3);
		}
	}
	render() {

		var image = this.state.imageCopy
			? this.state.imageCopy : 'noUserImage.jpg';
		let { imagePreviewUrl } = this.state;
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

		if (image != 'noUserImage.jpg') {
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + 'admin' + '/' + user.adminImage
		} else {
			imagePreviewUrl = constant.PRODUCTION_IMAGE_URL + 'uploads/common/noUserImage.jpg';
		}
		let $imagePreview = null;
		if (!imagePreviewUrl) {
			var folderName = (image == constant.DEFAULT_USER_IMAGE) ? constant.COMMON_FOLDER : constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/';
			imagePreviewUrl = this.state.imageCopy
				? this.state.imageCopy : constant.PRODUCTION_IMAGE_URL + folderName + image;
		}

		// if (user.image == constant.DEFAULT_USER_IMAGE) {
		// 	var imagePath = constant.PRODUCTION_IMAGE_URL + constant.COMMON_FOLDER + user.image;
		// } else {
		// 	var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		// }
		{ this.onrenderimage() }

		// var bloodGroupList = this.state.bloodGroupList;
		var countryCodeList = constant.PHONENOCOUNTRYCODE ? constant.PHONENOCOUNTRYCODE : [];

		console.log("on render", this.state)
		return (

			<div className="content-wrapper">
				<section className="content container-fluid">

					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li><Link to="#tab_1" onClick={this.onChangeTab.bind(this, 1)} data-toggle="tab" className={this.state.tabCLicked === 1 ? "active show" : ''}>Profile</Link></li>
										<li><Link to="#tab_2" onClick={this.onChangeTab.bind(this, 2)} data-toggle="tab" className={this.state.tabCLicked === 2 ? "active show" : ''}>Password Settings</Link></li>
										<li><Link to="#tab_3" onClick={this.onChangeTab.bind(this, 3)} data-toggle="tab" className={this.state.tabCLicked === 3 ? "active show" : ''}>Payment Configuration</Link></li>
										{/* <li><Link to="#tab_3" onClick={this.onChangeTab.bind(this, 3)} data-toggle="tab" className={this.state.tabCLicked === 3 ? "active show" : ''}>Delete Account</Link></li> */}
									</ul>

									<div className="tab-content">
										<div className={this.state.tabCLicked === 1 ? "tab-pane active show" : 'tab-pane'} id="tab_1">
											<div className="settingInput">
												<div className="row">
													<div className="col-md-12">
														<form name="uploadimage" >
															<div className="userProImg">
																<div className="image">
																	<img className="original" src={this.state.defaultImageURL} alt="" />
																	<Link className="hover" onClick={this.deleteImage} ><i className="fa fa-trash"></i></Link>
																</div>

																<input type="file" className="form-control" ref="file" name="image" id="fileID" onChange={(event) => { this.uploadAdminUserImage(event) }} onClick={(event) => { event.target.value = null }} style={{ 'display': 'none' }} />
																<label htmlFor="fileID" style={{ 'cursor': 'pointer' }}>
																	<SVGICONS.SpecialistProfileSvg />

																</label>
															</div>

														</form>
													</div>
												</div>

												<form>
													<div className="row">
														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="text" name="userName" value={this.state.userName ? this.state.userName.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter Name" />
																</div>
																<span className="help-block">{this.state.userName.message}</span>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/email_input_icon.svg')} alt="" /></i></span>
																	<input type="text" id="email" name="email" onChange={this.onChange} value={this.state.email ? this.state.email.value : ''} className="form-control" placeholder="Enter Email" />
																</div>
																<span className="help-block">{this.state.email.message}</span>
															</div>
														</div>
														<div className="col-md-6">
															<div className="row">
																<div className="col-md-2">
																	<div className="genderInfo ">Gender</div>
																</div>
																<div className="col-md-4 largescreencolumn5">
																	<div className="boxMrgB boxMrgT">
																		<div className="radio radio-primary">
																			<input type="radio" onChange={this.onChange} name="gender" id="gender1" value="Male" checked={this.state.gender.value === 'Male'} />
																			<label htmlFor="gender1"> Male </label>
																		</div>
																	</div>
																</div>
																<div className="col-md-4 largescreencolumn5">
																	<div className="boxMrgB boxMrgT landscape-radio">
																		<div className="radio radio-primary">
																			<input type="radio" name="gender" id="gender2" onChange={this.onChange} value="Female" checked={this.state.gender.value === 'Female'} />
																			<label htmlFor="gender2"> Female </label>
																		</div>
																	</div>
																</div>
															</div>
														</div>

														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/phone_input_icon.svg')} alt="" /></i></span>
																	<div className="dropdown cusmobile">
																		<select className="form-control" style={{ border: 0 }} name="phoneNoCountryCode" value={this.state.phoneNoCountryCode ? this.state.phoneNoCountryCode.value : '+91'} onChange={this.onChange.bind(this)} >
																			{(countryCodeList && countryCodeList.length) > 0 ? countryCodeList.map((option, index) => <option value={option} key={index}>{option}</option>) : ''}
																		</select>
																	</div>
																	<input id="phoneNo" style={{ marginLeft: 20 }} type="text" value={this.state.phoneNo ? this.state.phoneNo.value : ''} name="phoneNo" onChange={this.onChange} className="form-control p-d-20" placeholder="Phone Number" />
																</div>
																<span className="help-block">{this.state.phoneNo.message}</span>
															</div>
														</div>
														<div className="container">
															<div className="row">

																{
																	this.state.items.map(item => {
																		if (item.isChecked == true) {
																			return (<div disabled className="col-sm-3 checkboxspace"><CheckBox handleCheckChieldElement={this.handleCheckChieldElement} {...item} /></div>);
																		}
																		else {
																			return null
																		}
																	})
																}

																<span className="help-block">{this.state.userType.message}</span>
															</div>
														</div>

														<div className="col-md-12 text-center">
															<div className="bottomBtn">
																<button type="button" onClick={this.addEditUser} className="btn btn-warning btn-lg" >Save</button>
															</div>
														</div>

													</div>
												</form>
											</div>
										</div>

										<div className={this.state.tabCLicked === 2 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_2">
											<h2 className="subTitle text-center">Change Password</h2>
											<form>
												<div className="row">
													<div className="col-md-4 offset-md-4">
														<div className="boxMrgB toolTipDiv">
															<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/password_input_icon.svg')} alt="" /></i></span>
																<input type="password" name="currentPassword" className="form-control"
																	placeholder="Password" value={this.state.currentPassword.value} onChange={this.onPasswordSettingChange} placeholder="Current Password" />

																{/* <input type="password" name="currentPassword" className="form-control" onChange={this.onPasswordSettingChange} value={this.state.currentPassword} placeholder="Current Password" /> */}
															</div>
															<span className="help-block">{this.state.currentPassword.message}</span>


														</div>

														<div className="boxMrgB">
															<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/password_input_icon.svg')} alt="" /></i></span>
																<input type="password" name="password" className="form-control"
																	placeholder="New Password" value={this.state.password.value} onChange={this.onPasswordSettingChange} />

																{/* <input type="password" onChange={this.onPasswordSettingChange} name="newPassword" value={this.state.newPassword} className="form-control" placeholder="Enter New Password" /> */}
															</div>
															<span className="help-block">{this.state.password.message}</span>
															{this.state.popoverShow == true ? <div className="toolTip tooltipPass">
																<div className="tool_box mysetting_tool_box">
																	<p>Password must Meet the following
                                          requirements:
                                       </p>
																	<ul>
																		<li>{this.state.patternOne == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>} At least one letter</li>
																		<li>{this.state.patternTwo == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one capital letter</li>
																		<li>{this.state.patternThree == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}At least one number</li>
																		<li>{this.state.patternFour == true ? <i className="fa fa-check-circle checkGreen"></i> : <i className="fa fa-close checkGreen checkRed"></i>}Be at least 8 characters	</li>
																	</ul>
																</div>
															</div> : ''}
														</div>

														<div className="boxMrgB">
															<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa "><img src={require('../../../images/img/password_input_icon.svg')} alt="" /></i></span>
																<input type="password" className="form-control" id="cpassword" ref="cpassword" name="cpassword" placeholder="Confirm Password" value={this.state.cpassword.value} onChange={this.onPasswordSettingChange} />

																{/* <input type="password" className="form-control" name="newConfirmPassword" onChange={this.onPasswordSettingChange} value={this.state.newConfirmPassword} placeholder="Re-enter New Password" /> */}
															</div>
															<span className="help-block">{this.state.cpassword.message}</span>
														</div>
													</div>
													<div className="col-md-12 text-center">
														<div className="bottomBtn">
															<button type="button" onClick={this.changePassword} className="btn btn-warning btn-lg">Update</button>
														</div>
													</div>
												</div>
											</form>
										</div>
										<div className={this.state.tabCLicked === 3 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_3">
											<div>
												<form>
													<div className="row">
														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="number" name="transaction_charge" value={this.state.transaction_charge ? this.state.transaction_charge.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter Transaction  Charges" />
																</div>
																<span className="help-block">{this.state.transaction_charge.message}</span>
															</div>
														</div>
														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="number" name="commition_charges" value={this.state.commition_charges ? this.state.commition_charges.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Enter Commition Charges" />
																</div>
																<span className="help-block">{this.state.commition_charges.message}</span>
															</div>
														</div>
														<div className="col-md-6">
															<div className="boxMrgB">
																<div className="input-group inputBg"> <span className="input-group-addon"><i className="fa ">		<img src={require('../../../images/img/user_input_icon.svg')} alt="" /></i></span>
																	<input type="number" name="invoice_recurrance" value={this.state.invoice_recurrance ? this.state.invoice_recurrance.value : ''} onChange={this.onChange} className="form-control text-capitalize" placeholder="Recur after days" />
																</div>
																<span className="help-block">{this.state.invoice_recurrance.message}</span>
															</div>
														</div>
													</div>
													<div className="col-md-12 text-center">
														<div className="bottomBtn">
															<button type="button" onClick={this.savePaymentConfigration} className="btn btn-warning btn-lg">Save</button>
														</div>
													</div>
												</form>

											</div>
										</div>

										{/* <div className={this.state.tabCLicked === 3 ? "tab-pane changePassword active show" : 'tab-pane changePassword'} id="tab_3">
											<div>
												<h2 className="subTitle text-center">Warning!</h2>
												<p>Are you sure you want to delete your Account? This will delete all your personnel information along with the Health Records and appointments. Also this action cannot be reverted.</p>
											</div>
											<div className="bottomBtn">
												<button type="button" onClick={this.deleteProfile.bind(this)} className="btn btn-warning btn-lg" >Delete Profile</button>
											</div>
										</div> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>

				<div className="Copyrightafterlogin">
					<p>Medfix &copy; 2018. All rights reserved</p>
				</div>
			</div>

		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	return {
		// bloodGroupList: state.users.bloodGroupList,
		// latestPatientImage: state.users.latestPatientImage,
		adminUserData: state.adminUser.adminUserData ? state.adminUser.adminUserData : {},
		success: state.adminUser.adminUserData ? state.adminUser.adminUserData.success : false,
		userData: state.adminUser.userData ? state.adminUser.userData : {},
		userDataSuccess: state.adminUser.userData ? state.adminUser.userData.success : false,
		adminUserUpdatedData: state.adminUser.adminUserUpdatedData ? state.adminUser.adminUserUpdatedData : {},
		adminUserUpdatedSuccess: state.adminUser.adminUserUpdatedData ? state.adminUser.adminUserUpdatedData.success : false,
		paymentConfigData: state.adminUser.paymentConfigData? state.adminUser.paymentConfigData :{},

	};
}
//this tells what action should expose on props
//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(userActions, dispatch),
		usersAction: bindActionCreators(usersAction, dispatch),
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(AdminSetting);
